<template>
  <div class="finalizado">
    <h1>Formulário de dados pessoais enviado com sucesso</h1>
    <p>Entraremos em contato em breve.</p>
  </div>
</template>

<script>
export default {
  name: 'finalizado'
}
</script>
